/** Admin: mirror-tracked ingested documents per organization. */
import { apiGet } from '../client.js';
import type { IngestedDocument } from '../types.js';

export function listOrgDocuments(
  organizationId: string,
  filters: { collections?: string; status?: string; limit?: number } = {},
): Promise<IngestedDocument[]> {
  const query: Record<string, string> = {};
  if (filters.collections) query.collections = filters.collections;
  if (filters.status) query.status = filters.status;
  if (filters.limit) query.limit = String(filters.limit);
  return apiGet<IngestedDocument[]>(
    `/api/v1/admin/organizations/${organizationId}/documents`,
    query,
  );
}
